import { useNavigate, useLocation } from "react-router-dom";

const PublicNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (path) => (e) => {
    e.preventDefault();
    if (location.pathname !== path) navigate(path);
  };

  return (
    <div className="navbar" data-testid="public-navbar">
      <div />

      <ul className="nav-links">
        <li>
          <a href="/" onClick={go("/")}>Home</a>
        </li>
        <li>
          <a href="/about" onClick={go("/about")}>About</a>
        </li>
        <li>
          <a href="/services" onClick={go("/services")}>Services</a>
        </li>
        <li>
          <a href="/contact" onClick={go("/contact")}>Contact</a>
        </li>
      </ul>

      <button className="nav-cta" onClick={() => navigate("/promo")} data-testid="nav-cta">
        Get Started
      </button>
    </div>
  );
};

export default PublicNavbar;
